import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { transform: "translate(350, 460) scale(0.08,-0.08)" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-name",
  d: "M3505 3951 c-234 -57 -430 -228 -518 -451 -64 -163 -64 -367 0 -530\n70 -176 206 -321 378 -401 140 -66 86 -63 1035 -69 l865 -5 59 -29 c79 -39\n140 -102 178 -182 55 -119 40 -264 -40 -369 -21 -27 -59 -65 -86 -82 -98 -66\n-33 -63 -1293 -63 l-1143 0 0 -185 0 -185 1161 0 c1304 0 1230 -4 1395 75 220\n106 374 325 406 579 44 349 -187 690 -537 793 -55 16 -137 18 -920 23 l-860 5\n-57 27 c-76 35 -138 95 -179 170 -32 60 -34 68 -34 163 0 95 2 103 34 163 41\n75 103 135 179 170 l57 27 1068 3 1067 2 0 185 0 185 -1072 -1 c-982 0 -1079\n-2 -1143 -18z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-name",
  d: "M7354 3954 c-466 -78 -859 -417 -1008 -869 -60 -183 -59 -167 -63\n-957 l-4 -728 185 0 185 0 4 713 c3 698 4 714 26 797 42 161 154 349 269 451\n110 97 247 172 387 211 79 22 89 23 813 26 l732 3 0 -551 0 -550 -1025 0\n-1025 0 0 -185 0 -185 1025 0 1025 0 0 -365 0 -365 185 0 185 0 0 1285 0 1285\n-907 -1 c-718 -1 -925 -4 -989 -15z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-name",
  d: "M9870 2685 l0 -1285 185 0 185 0 0 1100 0 1100 1145 0 1145 0 0 185\n0 185 -1330 0 -1330 0 0 -1285z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-name",
  d: "M13854 3954 c-466 -78 -859 -417 -1008 -869 -60 -183 -59 -167 -63\n-957 l-4 -728 185 0 185 0 4 713 c3 698 4 714 26 797 42 161 154 349 269 451\n110 97 247 172 387 211 79 22 89 23 813 26 l732 3 0 -551 0 -550 -1025 0\n-1025 0 0 -185 0 -185 1025 0 1025 0 0 -365 0 -365 185 0 185 0 0 1285 0 1285\n-907 -1 c-718 -1 -925 -4 -989 -15z"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-name",
  d: "M10420 2685 l0 -185 900 0 900 0 0 185 0 185 -900 0 -900 0 0 -185z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("g", _hoisted_1, _hoisted_7))
}